import client from '../base-api';

const aiDocumentScanService = {
  aiDocumentScan(formData: FormData): Promise<any> {
    return client.post('/ai-document-scan/private-coaching', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  createPrivateCoachingFromDocumentScan(documentScanData: any) {
    return client.post('/ai-document-scan/private-coaching-create', documentScanData);
  },
};


export default aiDocumentScanService;
